export const formatJsonRemoveEmptyOrNull = (obj) => {
    /* eslint-disable */
    Object.keys(obj).forEach(k =>
        (obj[k] && typeof obj[k] === 'object') && formatJsonRemoveEmptyOrNull(obj[k]) ||
        (obj[k] === null || obj[k] === '') && delete obj[k]
    );
    /* eslint-enable */
    return obj;
}